var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monthly"},[_c('h1',[_vm._v("月租服务,功能开发中...")])])
}]

export { render, staticRenderFns }